export default "__VITE_ASSET__DTKeIWvb__"